import * as React from 'react';
import styled from 'styled-components';
import './buttonStyles.less';

const Button = ({
	type,
	className,
	children,
	id,
	disabled,
	onClick,
	textColour,
	backgroundColor,
	fontWeight,
	tabIndex,
	text,
	imgSrc,
	imgAlt,
	img
}: Props) => (
	<Element
		className={className}
		id={id}
		// eslint-disable-next-line react/button-has-type
		type={type}
		onClick={onClick}
		disabled={disabled}
		textColor={textColour}
		backgroundColor={backgroundColor}
		fontWeight={fontWeight}
		tabIndex={tabIndex}
	>
		<>
			{text && <span>{text}</span>}
			{imgSrc && imgAlt && (
				<ImageWrapper>
					<img src={imgSrc} alt={imgAlt} />
				</ImageWrapper>
			)}
			{img && <ImageWrapper>{img}</ImageWrapper>}
			{children}
		</>
	</Element>
);

interface Props extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
	textColour: string;
	backgroundColor: string;
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	text?: string;
	imgSrc?: string;
	imgAlt?: string;
	img?: JSX.Element;
	children?: JSX.Element | JSX.Element[];
	fontWeight?: string;
	type?: 'button' | 'submit' | 'reset';
	id?: string;
	disabled?: boolean;
	className?: string;
	tabIndex?: number;
}

Button.defaultProps = {
	text: null,
	imgSrc: null,
	imgAlt: null,
	img: null,
	children: null,
	type: 'button',
	id: null,
	disabled: false,
	className: null,
	fontWeight: '400',
	tabIndex: undefined
};

export default Button;

const ImageWrapper = styled.span`
	display: inline-block;
	position: relative;
	width: 20px;
	margin-left: 10px;
`;

const Element = styled.button<{ textColor: string; backgroundColor: string; fontWeight: string }>`
	color: ${(props) => props.textColor};
	background-color: ${(props) => props.backgroundColor};
	margin: 4px;
	font-size: 15px;
	line-height: 20px;
	font-weight: ${(props) => props.fontWeight};
`;
